<template>
  <div v-if="amount">
    <div class="flex-y-center gap-1">
      <img :src="icon" alt="Coin" class="w-4 h-4" />
      <span class="text-xs text-gray-450 font-semibold"> {{ title }} </span>
    </div>
    <div class="flex-y-center gap-1">
      <span class="text-sm font-bold leading-130" :key="amount" :class="color">
        ${{ Number(amount)?.toFixed(2) }}
      </span>
      <button
        @click="$emit('refreshExchange')"
        :disabled="loading"
        class="w-4 h-4 flex-y-center justify-center group transition-300 disabled:cursor-not-allowed"
      >
        <Transition name="fade" mode="out-in">
          <div :key="loading">
            <template v-if="loading">
              <div class="spinner-loading-animation" />
            </template>
            <template v-else>
              <span
                class="icon-refresh !text-sm text-gray-450 transition-300 group-hover:text-dark"
              />
            </template>
          </div>
        </Transition>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

interface Props {
  icon: string;
  title: string;
  amount: number;
  loading: boolean;
}
const props = defineProps<Props>();
defineEmits<{
  (e: "refreshExchange"): void;
}>();

let profit = null;
const color = ref("");

function compareValues(newValue) {
  if (profit === null) {
    profit = newValue;
    return "No previous value to compare";
  }

  let result = newValue > profit ? "green" : "red";
  profit = newValue; // Update oldValue to the new value for future comparisons
  return result;
}

watch(
  () => props?.amount,
  () => {
    color.value = compareValues(props?.amount);
  },
  { deep: true, immediate: true },
);
</script>

<style>
.green {
  animation: grow-animation 1000ms ease-in reverse;
}
.red {
  animation: low-animation 1000ms ease-in reverse;
}
@keyframes grow-animation {
  0% {
    color: #080a15;
  }
  50% {
    color: #16cc53;
  }
  100% {
    color: #080a15;
  }
}
@keyframes low-animation {
  0% {
    color: #080a15;
  }
  50% {
    color: red;
  }
  100% {
    color: #080a15;
  }
}
</style>
<style scoped>
.spinner-loading-animation {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side, #6f767e 94%, #0000) top/3.8px 3.8px no-repeat,
    conic-gradient(#0000 30%, #6f767e);
  -webkit-mask: radial-gradient(
    farthest-side,
    #0000 calc(100% - 3.8px),
    #000 0
  );
  animation: spinner-loading 1s infinite linear;
}

@keyframes spinner-loading {
  100% {
    transform: rotate(1turn);
  }
}
</style>
